import React, { useState } from 'react';
import { Icon } from '@material-ui/core';
import { getCachedSwatchImage } from './swatchImageCache';


const SwatchImagePreview = ({sku, title, sortOrder, imageUrl, alt, className}) => {
  const [broken, setBroken] = useState(false);
  const cachedBase64 = getCachedSwatchImage(sku, title, sortOrder);
  const src = cachedBase64 ? `data:image/png;base64,${cachedBase64}` : imageUrl;

  if (!src || broken) {
    return <Icon>image_not_supported_outlined</Icon>;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setBroken(true)}
    />
  );
};

export default SwatchImagePreview;
